"use strict";
/**
 * Created by Julio Perez on 9/20/2016.
 */
import angular from "angular";
import NavLinksLegendController from "./nav-links-legend.controller";


function navLinksLegend(){

    return {

        restrict: "E",
        scope: {
            name: "="
        },
        template: require("./nav-links-legend.html"),
        controller: NavLinksLegendController,
        controllerAs: "ctrl"

    };
}

export default angular
    .module("nav-links-legend.directive", [])
    .directive("navLinksLegend", navLinksLegend)
    .name;


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-legend/nav-links-legend.directive.js